export const CompanyIdentifierEnumValues = ['ADNZ', 'PUB'];
export const ContactRoleEnumValues = ['SALES', 'CUSTOMER'];
export const UserSourceEnumValues = ['ADCONSOLE', 'SSO'];
export const IdentityProviderTypeEnumValues = ['GOOGLE'];
export const DiscountValueTypeEnumValues = ['PERCENTAGE', 'AMOUNT'];
export const DiscountApplyToEnumValues = ['GROSS1', 'GROSS2', 'GROSS3', 'NET1', 'NET2', 'NET3'];
export const DiscountOperationTypeEnumValues = ['DISCOUNT', 'SURCHARGE'];
export const UserRoleEnumValues = ['ADMIN', 'USER_ADMIN', 'COMPANY_ADMIN', 'USER'];
export const RoleEnumValues = ['ADVERTISER', 'AGENCY', 'BROKER', 'OTHER', 'PUBLISHER'];
export const EmailPlaceholderEnumValues = [
    'USER_EMAIL',
    'SALES_CONTACT_EMAIL',
    'CREATOR_EMAIL',
    'ASSIGNEE_EMAIL',
    'CONTACT_EMAIL',
    'RECEIVERS',
    'COMPANY_GENERAL_EMAIL',
    'ADMANAGEMENT_IF_BOOKED_OR_SELFBOOKED',
    'PUBLIC_COMMENT_RECEIVER',
    'CAMPAIGN_INVOICE_EMAILS',
    'CAMPAIGN_COMMUNICATION_EMAIL',
    'CAMPAIGN_SCREENSHOT_EMAILS',
    'CAMPAIGN_CREATIVE_EMAILS',
    'CAMPAIGN_REPORT_EMAILS',
    'CAMPAIGN_SALES',
    'CAMPAIGN_CREATOR',
    'INVOICE_EMAILS',
];
export const PlaceholderEnumValues = [
    'COMPANY_NAME',
    'CAMPAIGN_LINK',
    'CAMPAIGN_NAME',
    'INTERNAL_ORDER_NUMBER',
    'SALES_UNIT_NAME',
    'CAMPAIGN_POSITIONS',
    'ATTACHMENT_LINKS',
    'MESSAGE',
    'ATTACHMENT_LIST',
    'CREATOR_NAME',
    'INVOICE_NUMBER',
    'SCREENSHOTS_ARCHIVE_LINK',
    'ACCOUNT',
    'CREATIVE_PREVIEW_LINKS',
    'REFERENCE_NUMBER',
    'CUSTOMER_NAME',
    'CAMPAIGN_SALES_NAME',
    'TASK_TOPIC',
];
export const MailTemplateTypeEnumValues = [
    'SEND_INVOICE',
    'SEND_INVOICE_CANCELLATION',
    'PAYMENT_REMINDER_1',
    'PARTIALLY_PAID_PAYMENT_REMINDER_1',
    'PAYMENT_REMINDER_2',
    'PARTIALLY_PAID_PAYMENT_REMINDER_2',
    'PAYMENT_REMINDER_3',
    'PARTIALLY_PAID_PAYMENT_REMINDER_3',
    'PAYMENT_PERSONAL_CALL_REMINDER',
    'PARTIALLY_PAID_PAYMENT_PERSONAL_CALL_REMINDER',
    'SEND_SCREENSHOTS',
    'SEND_POSITIONS_SCREENSHOTS',
    'REQUEST_CREATIVES',
    'SEND_REPORT',
    'SEND_END_CAMPAIGN_REPORT',
    'SEND_STATE_READY',
    'SEND_UNDERDELIVERED_REPORT',
    'COMMENT',
    'REPORTING_TOOL_MAIL',
    'OPS_CAMPAIGN_DECLINED',
    'POSITION_EXCLUDED',
    'PAYOUT_REPORT',
    'ACCOUNT_EXCLUDED',
    'OFFER_NOTIFICATION',
    'SELF_BOOKING_CAMPAIGN_ACTIVATED',
    'CREDIT_CARD_PAYMENT_SUCCESSFUL',
    'CREDIT_CARD_PAYMENT_FAILED',
    'SELFBOOKING_GREETING',
    'SELFBOOKING_SEND_REMINDER',
    'SELFBOOKING_SEND_OVERDUE',
    'SELFBOOKING_ORDER_CONFIRMATION',
    'SELFBOOKING_CAMPAIGN_UNDERDELIVERY',
    'SELFBOOKING_CAMPAIGN_FINISHED',
    'INVITATION',
    'RESTORE_PASSWORD',
    'SEND_ORDER',
    'SEND_OFFER',
    'SEND_PRINT_PROOFS',
    'OFFER_REJECTED',
    'OFFER_EXPIRED',
    'FUNNEL_TASK_ASSIGNED_NOTIFICATION',
    'FUNNEL_DECLINED_TASK_SNOOZING_NOTIFICATION',
    'FUNNEL_TASK_UNSNOOZED_NOTIFICATION',
    'SECOND_FACTOR_CONFIRMATION',
    'REQUEST_ANALOG_CREATIVES',
    'POST_DIGITAL_CONFIRMATION_NOTIFICATION',
    'POST_DIGITAL_CANCELLATION_NOTIFICATION',
    'DRAFT_CREATIVE_NOTIFICATION',
    'CREATIVE_DEACTIVATED_NOTIFICATION',
    'NO_GENERATIONS_DETECTED_ALERT',
    'BOUNCE',
    'TICKET_STATUS_CHANGE_NOTIFICATION',
    'TICKET_ASSIGNEE_CHANGE_NOTIFICATION',
    'TICKET_COMMENT_NOTIFICATION',
    'MANUAL_DISPATCH_NOTIFICATION',
];
export const ClientMailTemplateTypeEnumValues = [
    'SEND_INVOICE',
    'PAYMENT_REMINDER_1',
    'PARTIALLY_PAID_PAYMENT_REMINDER_1',
    'PAYMENT_REMINDER_2',
    'PARTIALLY_PAYMENT_REMINDER_2',
    'PAYMENT_REMINDER_3',
    'PARTIALLY_PAYMENT_REMINDER_3',
    'PAYMENT_PERSONAL_CALL_REMINDER',
    'PARTIALLY_PAYMENT_PERSONAL_CALL_REMINDER',
    'SEND_SCREENSHOTS',
    'REQUEST_CREATIVES',
    'SEND_REPORT',
    'SEND_END_CAMPAIGN_REPORT',
    'SEND_STATE_READY',
    'SEND_UNDERDELIVERED_REPORT',
    'COMMENT',
    'REPORTING_TOOL_MAIL',
    'FUNNEL_TASK_ASSIGNED_NOTIFICATION',
    'FUNNEL_DECLINED_TASK_SNOOZING_NOTIFICATION',
];
export const LanguageCodeEnumValues = ['DE', 'EN', 'FR', 'IT'];
export const UiLanguageEnumValues = ['DE', 'DE_AT', 'DE_DE', 'EN', 'FR', 'IT'];
export const TemporaryAccessPinStatusEnumValues = ['PENDING', 'USED', 'EXPIRED'];
export const OidcIssuerNameEnumValues = ['SWISS_POST', 'COOP'];
export const PrintOperationExportTypeEnumValues = ['TOPAS', 'CICLON', 'COOP', 'NONE'];
export const PrintCreativeExportTypeEnumValues = ['ONEVISION'];
export const SocialNetworkTypeEnumValues = ['FACEBOOK', 'INSTAGRAM', 'LINKEDIN', 'X'];
export const ExternalReferenceTypeEnumValues = ['STRING', 'NUMERIC'];
export const UiThemeEnumValues = ['DARK', 'LIGHT', 'SYSTEM'];
export {};
